<script>
  import { createEventDispatcher } from 'svelte';
  import { ignoreComment } from '../../../Api/api';
  import { getTime } from '../../../common/dates';
  import { containsLink, setLink, parseUserId } from '../../../common/utils.js';

  const dispatch = createEventDispatcher();

  export let channelId = '';
  export let thread = [];
  export let selectedCommentId = '';

  const onIgnoreBtnClicked = async (e, comment) => {
    e.stopPropagation();
    await ignoreComment(channelId, comment.commentId);
  };

  $: console.log('Thread: ', thread);
</script>

<div class="comments">
  {#if thread.length}
    {#each thread as comment}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div
        class="comment"
        on:click={() => dispatch('selected', comment)}
        class:selected={selectedCommentId === comment.commentId}
      >
        <div class="comment-info">
          <div class="comment-header">
            {#if comment.serverTime}
              <span class="timestamp">
                {`${comment.userName} ST: ${getTime(comment.serverTime.toDate())}`}
              </span>
            {:else}
              <span class="timestamp">{getTime(comment.created.toDate())}</span>
              <span class="user-name">{comment.userName}</span>
              <span class="user-id">({parseUserId(comment.userId)})</span>
            {/if}
            <div class="controls">
              <button class="ignoreBtn" on:click={(e) => onIgnoreBtnClicked(e, comment)}>
                <span class="material-icons">cancel</span>
              </button>
            </div>
          </div>
          <span class="content">
            {#if containsLink(comment.content)}
              {@html setLink(comment.content)}
            {:else}{comment.content}{/if}
          </span>
        </div>
      </div>
    {/each}
  {:else}
    <div class="no-msg">
      <p>Ingen meldinger.</p>
    </div>
  {/if}
</div>

<style src="./commentList.scss"></style>
